// General delay before starting any transition while panels finish animating
export const PAGE_TRANSITION_DELAY = 1000;

export const transitionSettings = {
  duration: 0.4,
  type: 'tween',
};
